import { render, staticRenderFns } from "./winitReceipt.vue?vue&type=template&id=4b6b6660&scoped=true"
import script from "./winitReceipt.vue?vue&type=script&lang=js"
export * from "./winitReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6b6660",
  null
  
)

export default component.exports